import { mapActions, mapState } from 'pinia';
import { usePageStore } from '@/store';
import util from '../common/util';
import disclaimer from '@/components/disclaimer';
import '@/components/sign-log/common-sign-log.scss';
export default {
    data: function() {
        return {
            disclaimerUniqId: util.uuidv4(),
            checkDisclaimer: true
        };
    },
    computed: {
        ...mapState(usePageStore, ['hasLender']),
        disclaimerPrivacyText() {
            return this.hasLender
                ? this.$t('common:register.LENDER_AGREEMENT_HTML')
                : this.$t('common:register.ADV_DISCLAIMER_HTML');
        },
        disclaimerSubmitDisabled({ submitDisabled, checkDisclaimer }) {
            return !checkDisclaimer || submitDisabled;
        }
    },
    methods: {
        ...mapActions(usePageStore, ['fetchHasLender', 'fetchLenderInfo']),
        handlerEnter(e) {
            if (e.key === 'Enter' && this.disclaimerSubmitDisabled) {
                e.preventDefault();
            }
        },
        updateChecked(val) {
            this.checkDisclaimer = val;
        }
    },
    components: { disclaimer },
    async created() {
        await this.fetchHasLender();
        await this.fetchLenderInfo();
    },
    mounted() {
        window.addEventListener('keydown', this.handlerEnter);
    },
    unmounted() {
        window.removeEventListener('keydown', this.handlerEnter);
    }
};
